/** 타사 브릿지 함수 */

import { mobileOS } from 'src/utils'

const os = mobileOS()

const alyac = {
  /**
   * ALYAC 앱 외부에서 url 오픈
   * @param redirectPath - 리다이렉트 경로(main, always, free_coupon)
   */
  startOutLinkUrl: (pCode: string, redirectPath: string) => {
    const url = (() => {
      if (redirectPath === 'main') {
        return `${window.location.origin}/web/join/cert?pCode=${pCode}`
      } else if (redirectPath.includes('always')) {
        return `${window.location.origin}/web/join/cert?pCode=${pCode}&redirectPath=${redirectPath}`
      } else if (redirectPath.includes('free_coupon')) {
        return `${window.location.origin}/web/splash?pCode=${pCode}&redirectPath=${redirectPath}`
      } else {
        return `${window.location.origin}/web/splash`
      }
    })()

    switch (os) {
      case 'android':
        try {
          if (typeof window !== 'undefined' && window.ALYACM_DATAU?.startOutLinkUrl) {
            window.ALYACM_DATAU.startOutLinkUrl(url)
          } else {
            throw new Error('ALYAC startOutLinkUrl not found')
          }
        } catch (error) {
          console.error('ALYAC startOutLinkUrl error', error)
        }
        break
      case 'ios':
        break
      default:
        window.open(url, '_blank')
        break
    }
  },
}

export const ExternalBridge = { ALYAC: alyac }
